<div class="py-2 px-2 py-md-5 px-md-5">
    <div *ngIf="isLoading; else content">
        <div class="d-flex justify-content-center mt-5">
            <mat-spinner></mat-spinner>
        </div>
    </div>
    <ng-template #content>
        <div class="row">
            <div class="col-md-6">
                <mat-card class="bg-white mat-elevation-z3">
                    <div class="d-flex flex-row-reverse link-secondary mx-2 mt-2" (click)="back()"
                         style="cursor: pointer" (keydown.backspace)="back()" role="button" aria-hidden="true">
                        <mat-icon aria-hidden="false" matTooltip="Zamknij" matTooltipPosition="below">close</mat-icon>
                    </div>
                    <div class="col-9 header">
                        <mat-card-header>
                            <mat-card-title>
                                <mat-icon class="mx-1" color="primary">directions_car</mat-icon>
                                Samochód
                            </mat-card-title>
                            <mat-card-subtitle>Szczegółowe informacje na temat samochodu.</mat-card-subtitle>
                        </mat-card-header>
                    </div>
                    <mat-card-content>
                        <div class="pt-4">
                            <ul class="no-bullets">
                                <li><h5>Nr rejestracyjny: <b
                                    class="text-primary-color">{{ car.registration_number }}</b></h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li><h5>Marka i model: <b class="text-primary-color">{{ car.car_brand }}</b></h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li><h5>VIN: <b class="text-primary-color">{{ car.car_vin ? car.car_vin : 'brak' }}</b>
                                </h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li><h5>Rok produkcji: <b
                                    class="text-primary-color">{{ car.production_date | date: 'yyyy' }}</b></h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li><h5>Data końca przeglądu: <b
                                    class="text-primary-color">{{ car.inspection_date | date: 'dd.MM.yyyy' }}</b></h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li><h5>Data końca ubezpieczenia: <b
                                    class="text-primary-color">{{ car.insurance_end_date | date: 'dd.MM.yyyy' }}</b>
                                </h5>
                                </li>
                            </ul>
                            <ul class="no-bullets">
                                <li><h5>Opis: <b
                                    class="text-primary-color">{{ car.description ? car.description : 'brak' }}</b>
                                </h5>
                                </li>
                            </ul>
                            <div *ngIf="car.status" class="pt-2 text-center">
                                <h5 class="text-success"><i class="fa-solid fa-car-side text-success"></i> Archiwalny
                                </h5>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <div class="col-md-6 text-center py-5">
            <button mat-stroked-button (click)="back()">
                <i class="fa-solid fa-rotate-left"></i> Zamknij
            </button>
            <button *ngIf="!car.status" class="mx-2" mat-stroked-button color="warn" (click)="completed()"><i
                class="fa-solid fa-check"></i>
                Archiwizuj
            </button>
            <button *ngIf="!car.status" mat-stroked-button (click)="editCar()"><i
                class="fa-solid fa-pen-to-square"></i>
                Edytuj
            </button>
        </div>
    </ng-template>
</div>
